// src/pages/menu/ContinentalWaitersDashboard.jsx
import React from 'react';
import LocationWaitersDashboard from '../LocationWaitersDashboard';

const ContinentalWaitersDashboard = () => {
  return <LocationWaitersDashboard locationKey="continental" />;
};

export default ContinentalWaitersDashboard;